import React, { useEffect, useState } from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { Button } from '@mui/material';

import { useNavigate } from 'react-router-dom';

import api from '../../API/api';

import GeneralAction from '../panel/generalAction';



export default function ViewCourses(props) {

    const navigation = useNavigate()




    return (
        <div className='py-3'>
            <div className="row">
                <div className='py-3'>
                    <Button variant='contained' color='error' fullWidth>{props.school && props.school.schoolName}</Button>
                </div>
            </div>

            <TableContainer component={Paper}>
                <Table sx={{ minWidth: 650 }} size="small" aria-label="a dense table">
                    <TableHead sx={{ backgroundColor: 'black' }}>
                        <TableRow>
                            <TableCell sx={{ color: 'white', fontWeight: '800', padding: '15px' }}>Course</TableCell>
                            <TableCell sx={{ color: 'white', fontWeight: '800', padding: '15px' }} >Duration</TableCell>
                            <TableCell sx={{ color: 'white', fontWeight: '800', padding: '15px' }} >Eligibility</TableCell>
                            <TableCell sx={{ color: 'white', fontWeight: '800', padding: '15px', width: '200px' }} >Session</TableCell>
                            <TableCell sx={{ color: 'white', fontWeight: '800', padding: '15px' }} align="right">Action</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {props.courses && props.courses.map((row) => (
                            <TableRow
                                key={row.id}
                                sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                            >
                                <TableCell >{row.courseName} {row.shortName && <>({row.shortName})</>} </TableCell>
                                <TableCell >{row.duration} ({row.durationType}/{row.durationType}s)</TableCell>
                                <TableCell >{row.eligibility} </TableCell>
                                <TableCell >
                                    {
                                        new Date(row.effected_from).toLocaleString("default", { month: "short", })
                                        + ", " +
                                        new Date(row.effected_from).getFullYear()}
                                    &nbsp; to &nbsp; 
                                    {row.effected_to === 'present' ? 'Present' : <>
                                        {
                                            new Date(row.effected_to).toLocaleString("default", { month: "short", })
                                            + ", " +
                                            new Date(row.effected_to).getFullYear()}
                                    </>
                                    }



                                    {/* {row.effected_from} - {row.effected_to} */}
                                </TableCell>
                                <TableCell align="right">
                                    {/* <Button size='small' onClick={() => navigation(`/admin/addCourse/${row.id}`)} > */}
                                    <Button size='small' >
                                        <GeneralAction data={row} type={'course'} handleClickOpen={props.handleClickOpen} handleClose={props.handleClose} setModalData={props.setModalData} handleCopyCourse={props.handleCopyCourse} />
                                    </Button>
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>

        </div>
    );
}